{
  "hva-er-et-nedbetalingslan": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Et nedbetalingslån er et lån hvor du har avtalt nedbetalingstiden med den du låner fra på forhånd. Du har ikke muligheten til å låne opp igjen det du har betalt inn på lånet, uten at dette er avtalt med utlåner. De fleste alminnelige forbrukslånene på det norske markedet i dag kan beskrives som nedbetalingslån. </p>\n",
    "id": "cG9zdDo1NQ==",
    "slug": "hva-er-et-nedbetalingslan",
    "status": "publish",
    "title": "Hva er et nedbetalingslån?",
    "uri": "/hva-er-et-nedbetalingslan/"
  },
  "hvem-kan-soke-om-et-forbrukslan-hos-scoopr": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>For å søke om et forbrukslån hos oss må du ha fylt 18 år, norsk personnummer, ingen betalingsanmerkninger, og du må ha en årlig inntekt på minst 140 000 kroner før skatt. </p>\n\n\n\n<p>Selv om du oppfyller alle disse kravene er det ikke gitt at bankene kan tilby deg et lån. Det er nemlig mange faktorer som spiller inn når bankene vurderer en lånesøknad: inntekt, betjeningsevne, kredittverdighet og eksisterende gjeld er typiske ting som er med på å avgjøre hvordan bankene vurderer søknaden din.</p>\n\n\n\n<p></p>\n",
    "id": "cG9zdDo0Nw==",
    "slug": "hvem-kan-soke-om-et-forbrukslan-hos-scoopr",
    "status": "publish",
    "title": "Hvem kan søke om et forbrukslån hos Scoopr?",
    "uri": "/hvem-kan-soke-om-et-forbrukslan-hos-scoopr/"
  },
  "kan-jeg-endre-lanebelopet-eller-lopetiden": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Ja, har du mottatt et tilbud, men ønsker å gjøre endringer på tilbudet før du signerer avtalen, kan du kontakte kundesenteret vårt som fikser dette for deg. </p>\n\n\n\n<p>Merk deg at bankene ikke fritt kan tilby deg den nedbetalingstiden du ønsker. De kan ikke tilby deg en nedbetalingstid som gjør at  refinansieringslånet ditt blir dyrere enn de lånene du betalte på før du refinansierte. De kan heller ikke tilby deg et lån om de ser at det kan bli vanskelig for deg å betjene lånet.</p>\n\n\n\n<p>Søker du et forbrukslån med et annet formål enn refinansiering kan bankene maks tilby deg en nedbetalingstid på fem år. Dette er en følge av nye regler for forbrukslån som Finansdepartementet lanserte i 2019.</p>\n",
    "id": "cG9zdDo1Mg==",
    "slug": "kan-jeg-endre-lanebelopet-eller-lopetiden",
    "status": "publish",
    "title": "Kan jeg endre lånebeløpet eller løpetiden?",
    "uri": "/kan-jeg-endre-lanebelopet-eller-lopetiden/"
  },
  "kan-jeg-ha-med-medsoker-i-soknaden": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Ja, du kan gjerne ha med deg en medsøker i søknaden. Ta kontakt med kundesenteret vårt direkte på telefon om dette er noe du ønsker. Husk at medsøkeren din må oppfylle de samme kravene om alder, personnummer, inntekt og kredittverdighet som deg.</p>\n",
    "id": "cG9zdDo1MA==",
    "slug": "kan-jeg-ha-med-medsoker-i-soknaden",
    "status": "publish",
    "title": "Kan jeg ha med medsøker i søknaden?",
    "uri": "/kan-jeg-ha-med-medsoker-i-soknaden/"
  },
  "hvordan-soker-jeg-pa-refinansiering-hos-scoopr": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Det gjør du enkelt ved å svare på spørsmålene du finner under denne artikkelen. Om du i tillegg bruker BankID for å dele dine opplysninger fra Gjeldsregisteret, gjør dette søknadsprosessen enda enklere. Det vil også gi oss et bedre grunnlag for å vurdere hvilken løsning som passer nettopp deg best.</p>\n\n\n\n<p>Har du spørsmål til utfylling av søknaden, kontakt en av våre hyggelige saksbehandlere på telefon 488 46 665 (man. – fre.: 08:00 – 20:00)</p>\n",
    "id": "cG9zdDo0OQ==",
    "slug": "hvordan-soker-jeg-pa-refinansiering-hos-scoopr",
    "status": "publish",
    "title": "Hvordan søker jeg på refinansiering hos Scoopr?",
    "uri": "/hvordan-soker-jeg-pa-refinansiering-hos-scoopr/"
  },
  "samle-smalan-og-kredittkort": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Det å betale på flere smålån og kredittkort kan fort bli mye dyrere enn det trenger å være. </p>\n\n\n\n<p>Kredittkort har gjerne en gjennomsnittsrente som er vesentlig høyere enn det som er vanlig på et lån. Betaler du til flere aktører hver måned, betaler du også gjerne termingebyrer på hver enkelt regning. Summen av disse alene kan fort bli flere hundre kroner i måneden. </p>\n\n\n\n<p>Ved å samle dine smålån og kredittkort vil du kunne</p>\n\n\n\n<ul><li>Få bedre renter, og mindre kostnader på gjelden din</li><li>Få en bedre oversikt over gjelden din</li><li>Bruke mindre tid på regningbetaling</li></ul>\n\n\n\n<p>Selv om du har full kontroll på sin egen økonomi, og uten problemer klarer å betjene lån og kredittkort, kan det likevel være mye å spare på en refinansiering. Det finnes morsommere ting å bruke pengene sine på enn renter og gebyrer!</p>\n",
    "id": "cG9zdDo0NA==",
    "slug": "samle-smalan-og-kredittkort",
    "status": "publish",
    "title": "Samle smålån og kredittkort",
    "uri": "/samle-smalan-og-kredittkort/"
  },
  "hva-er-gjeldsregisteret": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Gjeldsregisteret ble lansert 1. juli 2019. Hensikten med et slikt register er at du som privatperson skal kunne logge deg inn og sjekke dine egne gjeldsopplysninger. Det er også et mål at gjeldsregisteret skal bidra til at færre havner i gjeldsproblemer.</p>\n\n\n\n<p>I dag er det to selskapet som har tillatelse til å drifte gjeldsregister i Norge: Gjeldsregisteret AS og Norsk Gjeldsinformasjon AS. Som privatperson skal du få de samme opplysningene, uavhengig av hvilken løsning du velger å bruke. Det er viktig å være klar over at det kun er usikret gjeld som vil vises i gjeldsregisteret. Det vil si at du kan logge deg inn og se info om hva du har av forbrukslån, kredittkortgjeld og kjøpekreditter, men ikke boliglån og studielån, for eksempel.</p>\n\n\n\n<p>Når du logger deg inn får du svar på:</p>\n\n\n\n<ul><li>hvilken type forbrukskreditt du har</li><li>hva saldoen er</li><li>hva den effektive renta er</li></ul>\n\n\n\n<p>Om du har forbrukslån får du også info om det opprinnelige lånebeløpet og nedbetalingstiden på lånet. Har du kredittkort kan du se info om kredittgrensen på kortet.</p>\n",
    "id": "cG9zdDo1Mw==",
    "slug": "hva-er-gjeldsregisteret",
    "status": "publish",
    "title": "Hva er gjeldsregisteret?",
    "uri": "/hva-er-gjeldsregisteret/"
  },
  "hvor-stort-lan-kan-jeg-fa": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Er du på utkikk etter et usikret lån, enten behovet er refinansiering eller noe annet, kan du søke om et beløp mellom 20 000 og 500 000 kroner. Hvor stort lån bankene faktisk kan tilby deg, er avhengig av mange faktorer: Betjeningsevne, kredittverdighet, inntekt, og lån du allerede har er typisk ting som avgjør hvordan bankene vurderer deg som kunde.</p>\n",
    "id": "cG9zdDo1MQ==",
    "slug": "hvor-stort-lan-kan-jeg-fa",
    "status": "publish",
    "title": "Hvor stort lån kan jeg få?",
    "uri": "/hvor-stort-lan-kan-jeg-fa/"
  },
  "betaler-dere-ut-min-eksisterende-gjeld": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Ja, om du søker om refinansiering gjennom Scoopr vil tilbudsbanken normalt sett sørge for at gjelden din blir betalt ned, enten det er snakk om kredittkort, forbrukslån eller avbetalingslån.</p>\n",
    "id": "cG9zdDo0OA==",
    "slug": "betaler-dere-ut-min-eksisterende-gjeld",
    "status": "publish",
    "title": "Betaler dere ned min eksisterende gjeld?",
    "uri": "/betaler-dere-ut-min-eksisterende-gjeld/"
  },
  "retningslinjer-for-forbrukslan": {
    "categories": {
      "category": [
        {
          "id": 5,
          "name": "Public"
        },
        {
          "id": 3,
          "name": "Refinansiering"
        }
      ]
    },
    "content": "\n<p>Våren 2019 kom det nye kjøreregler for forbrukslån. Slik påvirker det deg som forbruker:</p>\n\n\n\n<ul id=\"block-f877a40c-7f4a-4d0f-ba84-5e19b8649ef8\"><li>Den maksimale nedbetalingstiden du kan få på refinansiering av forbrukslån er 15 år.</li><li>Bankene kan gi deg maks 5 års nedbetalingstid på nye forbrukslån.</li><li>Den totale gjelden din kan ikke overstige fem ganger inntekten din. </li><li>Du må tåle en renteøkning på 5 % på den samlede gjelden.</li></ul>\n\n\n\n<p>I forbindelse med dette ønsker bankene å vite:</p>\n\n\n\n<ul><li><em>Hvor lang nedbetalingstid har du på dine eksisterende lån</em>?</li><li><em>Hvor mye betaler du på de ulike lånene og kortene? </em></li></ul>\n\n\n\n<p>For å gjøre en best mulig vurdering av deg som kunde, vil bankene også vite hvor høy kredittgrense du har på eventuelle kredittkort og avbetalingskjøp – ikke bare hvor mye du skylder i dag.</p>\n",
    "id": "cG9zdDo0Ng==",
    "slug": "retningslinjer-for-forbrukslan",
    "status": "publish",
    "title": "Retningslinjer for forbrukslån",
    "uri": "/retningslinjer-for-forbrukslan/"
  }
}
